import { Auth } from "aws-amplify";
import usersService from "../../components/main/body/screens/IAM/Users/users.service";
import { Mixpanel, isEmpty } from "../Helper";
import { EndpointService } from "../../services/endpoint/endpoint.service";
import { useStore } from "../../Hooks/useStore";
import MedicalEmergencyCard from "../../components/main/body/screens/MedicalEmergenciesMainScreen/common/MedicalEmergencyCard/MedicalEmergencyCard";
import { useContext,createContext } from "react";
import { RootStore } from "../../store/RootStore";
import { unsubscribeToTopic, unsubscribeToTopicnew } from "../../App";

type RootStoreType = RootStore;


export const generateDeviceId = async () => {
    const userAgent = window.navigator.userAgent;
    console.log("userAgent",userAgent);
    const platform = window.navigator.platform;
    console.log("platform",platform);
    const deviceID = `${userAgent}-${platform}`;
    console.log("deviceID",deviceID);
    return deviceID;
}

// Save Device Token
export const saveDeviceToken = async (isLogout?: boolean) => {
    /*
        if isLogout is true that means user tap on logout button so setting null to deviceToken
        else set syncUniqueId to deviceToken
    */
   try {
    let username;
   
    // get user info
    let userInfo = localStorage.getItem("userinfo");
    console.log("userInfo in checkMultiLogin", userInfo);
    if(userInfo) {
        username = JSON.parse(userInfo)?.username;
    }
    if (username!=undefined && username != null) {
        let result = await usersService.saveDeviceToken(username,await generateDeviceId());
        console.log(result);
    }
   } catch(error) {
    console.error("Error occurred while save device ID:",error);
   }
}




// remove session
export const logoutSession = async (rootStore:RootStoreType) => {
   
    // logout user and clear session and reset mixpanel user
    try {
        let username;
       
        // get user info
        let userInfo = localStorage.getItem("userinfo");
        console.log("userInfo in logoutSession", userInfo);
        if(userInfo) {
            username = JSON.parse(userInfo)?.username;
        }
        console.log("username logoutSession", username);
        Auth.signOut();
        if(username)
            {
        Mixpanel.track("web_user_logout",{name:username})
            }
        Mixpanel.resetUser(); // clearing mixpanel user session
        localStorage.clear();
        
       unsubscribeToTopic(rootStore);
        
        // await EndpointService.removeRegisterEndpoint(username)
        // .then((result) => {window.location.replace("/");})
        // .catch((error) => {
        //     console.error("Error occure in remove endpoint", error);
        //     window.location.replace("/");
        // })
        window.location.replace("/");
    } catch (error) {
        console.log(error);
    }
  };

  export const logoutSessionnew = async () => {
   
    // logout user and clear session and reset mixpanel user
    try {
        let username;
       
        // get user info
        let userInfo = localStorage.getItem("userinfo");
        console.log("userInfo in logoutSession", userInfo);
        if(userInfo) {
            username = JSON.parse(userInfo)?.username;
        }
        console.log("username logoutSession", username);
        Auth.signOut();
        if(username)
            {
        Mixpanel.track("web_user_logout",{name:username})
            }
        Mixpanel.resetUser(); // clearing mixpanel user session
        localStorage.clear();
        
        unsubscribeToTopicnew();
        
        // await EndpointService.removeRegisterEndpoint(username)
        // .then((result) => {window.location.replace("/");})
        // .catch((error) => {
        //     console.error("Error occure in remove endpoint", error);
        //     window.location.replace("/");
        // })
        window.location.replace("/");
    } catch (error) {
        console.log(error);
    }
  };

// Check Multi Login
export const CheckForMultiLogin = async (user?:any,isAppStart?: boolean) => {
    try {
        let userData = await user;
        console.log("user", userData);

        // device id
        let deviceId = await generateDeviceId();
    
        // let user2 = Auth.currentUserInfo();
        // user2.then((result) => {
        //     console.log("result", result);
        // })
        // .catch((error) => {
        //     console.log("user2", error);
        // })


        // get store device token
        let res = await usersService.getDeviceToken(userData.username)
        console.log("getDeviceToken", res);
        if (res.deviceToken != null) {
            // Perform your logic here based on res
            let check = res.deviceToken == deviceId;
            console.log(check);
            if (deviceId !== res.deviceToken) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }

    //     if (isEmpty(res.deviceToken)) {
    //         await saveDeviceToken();
    //         return false;
    //    } else if (deviceId !== res.deviceToken) {
    //         return true;
    //    } else if (deviceId === res.deviceToken) {
    //     return false;
    //    } else {
    //        await logoutSession();
    //        return false;
    //    }
    } 
    catch(error) {
        console.error("Error occurred while generating device ID:",error);
    }

    return true;
}

export const loadStateFromStorage = () => {
    const serializedState = localStorage.getItem('isMultilogin');
    if (serializedState === null) {
        return undefined;
    }
    return JSON.parse(serializedState);
};

export const saveStateToStorage = (state: boolean) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('isMultilogin', serializedState);
    } catch (error) {
        console.log('Error saving state to localStorage:', error);
    }
};